import { memo, useMemo } from 'react';
import { Line } from 'react-chartjs-2';

import './registerCharts.js';
import { useChartPalette } from './useChartPalette.js';

const SPARK_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  animation: false,
  events: [],
  plugins: { legend: { display: false }, tooltip: { enabled: false } },
  scales: { x: { display: false }, y: { display: false } },
};

/**
 * Tiny axis-less trend line for metric cards. Renders nothing with <2 points.
 * Memoized so metric grids don't redraw every canvas on unrelated re-renders;
 * an explicit `color` prop opts out of theme tracking (palette accent default).
 *
 * @param {{ data: number[], height?: number, color?: string }} props
 */
function SparklineBase({ data, height = 32, color }) {
  const palette = useChartPalette();
  const stroke = color || palette?.accent || '#1d4ed8';
  const chartData = useMemo(() => {
    if (!Array.isArray(data) || data.length < 2) return null;
    return {
      labels: data.map((_, i) => i),
      datasets: [
        {
          data,
          borderColor: stroke,
          borderWidth: 1.5,
          pointRadius: 0,
          tension: 0.35,
          fill: false,
        },
      ],
    };
  }, [data, stroke]);

  if (!chartData) {
    return null;
  }
  return (
    <div className="metric-spark" style={{ height }} aria-hidden="true">
      <Line data={chartData} options={SPARK_OPTIONS} />
    </div>
  );
}

export const Sparkline = memo(SparklineBase);
